<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="任务名称：" prop="name">
            <el-input style="width: 424px;" v-model="ruleForm.name" placeholder="请输入任务名称"></el-input>
          </el-form-item>
          <el-form-item label="副标题：" prop="subTitle">
            <el-input style="width: 424px;" v-model="ruleForm.subTitle" placeholder="请输入副标题"></el-input>
          </el-form-item>
          <el-form-item label="图片：" prop="thumb">
            <el-upload
              :action="baseUrl+'/system/common/upload/uploadFile'"
              list-type="picture-card"
              :headers="{'Authorization': token}"
              :multiple="false"
              :limit="1"
              :file-list="fileList"
              :on-remove="delImgBtn"
              :on-success="bannerImgBtn">
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">建议尺寸：96*96px，若需要更换图片，请先删除原图片</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="获得积分：" prop="getIntegralNum">
            <el-input style="width: 424px;" v-model="ruleForm.getIntegralNum" placeholder="请输入完成任务获得积分"></el-input>
          </el-form-item>
          <el-form-item label="排序：" prop="sort">
            <el-input style="width: 424px;" v-model="ruleForm.sort" placeholder="请输入排序（默认 1 ）"></el-input>
          </el-form-item>
          <el-form-item label="是否开启：" prop="status">
            <el-switch
              v-model="ruleForm.status"
              active-color="#1890FF"
              inactive-color="#CCCCCC">
            </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { saveIntegralTask, updateIntegralTask, fetchIntegralTaskDetailById } from '@/api/integral'
export default {
  name: 'IntegralMallTaskAdd',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      dataId: this.$route.query.dataId,
      fileList: [],
      ruleForm: {
        name: '',
        subTitle: '',
        thumb: '',
        getIntegralNum:'',
        sort: '',
        status: false
      },
      rules: {
        name: [
          { required: true, message: '请输入任务名称', trigger: 'blur' }
        ],
        subTitle: [
          { required: true, message: '请输入副标题', trigger: 'blur' }
        ],
        thumb: [
          { required: true, message: '请上传图片', trigger: 'blur' }
        ],
        getIntegralNum: [
          { required: true, message: '请输入完成任务获得积分', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    let token = sessionStorage.getItem('token')
    if (!token) {
      token = ''
    }
    this.token = token;
    if (this.dataId != '') {
      let that = this
      fetchIntegralTaskDetailById({ id: that.dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.ruleForm.name = data.name
          that.ruleForm.subTitle = data.subTitle
          let status = false
          if (data.status === 1) {
            status = true
          }
          that.ruleForm.status = status
          that.ruleForm.sort = data.sort
          that.ruleForm.thumb = data.thumb
          that.fileList.push({url: data.thumb})
          that.ruleForm.getIntegralNum = data.getIntegralNum
        }
      })
    }
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    bannerImgBtn (file) {
      this.ruleForm.thumb = file.data.fileUrl
    },
    /* 删除上传的图片 */
    delImgBtn(file,fileList){
      var imgUrl = '';
      fileList.forEach(function(item){
        imgUrl = item.url;
      });
      this.ruleForm.thumb = imgUrl;
    },
    // 保存操作
    saveBtn () {
      let that = this
      let dataId = that.dataId
      let name = that.ruleForm.name
      let subTitle = that.ruleForm.subTitle
      let thumb = that.ruleForm.thumb
      let getIntegralNum = that.ruleForm.getIntegralNum
      let status = that.ruleForm.status ? 1 : 0
      let sort = that.ruleForm.sort === '' ? 1 : that.ruleForm.sort
      if (name === '') {
        this.$message.error('请输入任务名称')
        return false
      }
      if (subTitle === '') {
        this.$message.error('请输入副标题')
        return false
      }
      if (thumb === '') {
        this.$message.error('请上传图片')
        return false
      }
      if (getIntegralNum === '') {
        this.$message.error('请输入完成任务获得积分')
        return false
      }
      let passData = {
        name: name, subTitle: subTitle, status: status, thumb: thumb, getIntegralNum: getIntegralNum, sort: sort
      }
      if (dataId !== '') {
        passData.id = dataId;
        updateIntegralTask(passData).then((res) => {
          that.backDataFun(res)
        })
      }else{
        saveIntegralTask(passData).then((res) => {
         that.backDataFun(res)
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/integralMall/TaskAdd.vue